import { render, staticRenderFns } from "./RoomRateRegistration.vue?vue&type=template&id=34cbb97b&scoped=true&"
import script from "./RoomRateRegistration.vue?vue&type=script&lang=js&"
export * from "./RoomRateRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RoomRateRegistration.vue?vue&type=style&index=0&id=34cbb97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbb97b",
  null
  
)

export default component.exports